import app from 'app';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      fnCloseNotification: null,
    };
  },

  computed: {
    ...mapState({
      timelineDuration: (state) => state.story?.timelineDuration,
      maxStoryDuration: (state) => {
        const programmer = _.find(tk.context.relatedProgrammerList, {
          id: state.story?.programmerId,
        });
        return programmer?.maxStoryDuration;
      },
    }),

    isTooLong() {
      return !app.validate.storyDuration(
        this.timelineDuration,
        this.maxStoryDuration
      );
    },

    alertMessage() {
      const duration = moment
        .duration(this.maxStoryDuration, 'seconds')
        .humanize();
      return app.culture
        .get('alert.STORY_TOO_LONG_TIMELINE_DESC1')
        .format(duration);
    },
  },

  watch: {
    isTooLong: {
      immediate: true,
      handler(value) {
        if (value) {
          app.notificationController.push({
            type: 'INFO',
            text: this.alertMessage,
            timeout: app.TIME.minute(30),
            uniqueGroupName: 'TIMELINE_TOO_LONG',
            trigger: {
              close: (fnClose) => {
                this.$data.fnCloseNotification = fnClose;
              },
            },
          });
        } else {
          if ('function' === typeof this.$data.fnCloseNotification) {
            this.$data.fnCloseNotification();
            this.$data.fnCloseNotification = null;
          }
        }
      },
    },
  },
};
